import PropTypes from "prop-types";

import { FlexContainers, Paragraph2, SVG, WrapperContainer } from "../../../../../components";

const FeaturesListRow = ({ features }) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart}>
      {features.map((feature) => (
        <WrapperContainer
          Container={FlexContainers.FlexRowStart}
          gap={8}
          width={250}
          key={feature?.code ?? feature?.name}>
          {feature.name || feature.value ? <SVG.CheckMark /> : <SVG.CrossMark />}
          <Paragraph2>{feature?.settingName ?? feature?.name}</Paragraph2>
        </WrapperContainer>
      ))}
    </WrapperContainer>
  );
};

FeaturesListRow.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      settingName: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.bool.isRequired
    })
  ).isRequired
};

export default FeaturesListRow;
